module.exports = __webpack_public_path__ + "img/image.04e365a0.png";